import { render, staticRenderFns } from "./index-shopList.vue?vue&type=template&id=d570d308&scoped=true&"
import script from "./index-shopList.vue?vue&type=script&lang=js&"
export * from "./index-shopList.vue?vue&type=script&lang=js&"
import style0 from "./index-shopList.vue?vue&type=style&index=0&id=d570d308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d570d308",
  null
  
)

export default component.exports